'use strict';

import { BaseElement } from '../../interfaces/BaseElement';
import { Cloudflare } from '../../api/Cloudflare';

const DEFAULT_SETTINGS = {
    active: false,
    passwords: []
};

export class Password {
    constructor () {
        this.params = config.features.protect || DEFAULT_SETTINGS;
        this.valid = false;
    }

    create() {
        if (!this.params.active) return new Promise(resolve => resolve());

        this.container = new BaseElement()
            .addClass('protected')
            .appendTo(document.body)
            .DOMElement;

        const logo = new BaseElement()
            .addClass('protected-logo')
            .appendTo( this.container)
            .DOMElement;

        const body = new BaseElement()
            .addClass('protected__body')
            .appendTo(this.container)
            .DOMElement;

        const {projectFolder,cdnRepository} = config;
        const url = Cloudflare.resize(`${cdnRepository}/${projectFolder}/resources/img/logo.png`,{
            width: 500
        });
        logo.style.backgroundImage = `url(${url})`;

        // const loginBlock = new BaseElement()
        //     .addClass('protected__body-element')
        //     .appendTo(body)
        //     .DOMElement;

        const passwordBlock = new BaseElement()
            .addClass('protected__body-element')
            .appendTo(body)
            .DOMElement;

        // const userName = new BaseElement('input')
        //     .addClass('login-input','protected-input')
        //     .event('input',this.removeError.bind(this))
        //     .appendTo(loginBlock)
        //     .addAttribute('id','login')
        //     .addAttribute('required',true)
        //     .DOMElement;

        // new BaseElement('label')
        //     .addClass('protected-label')
        //     .innerHtml('Login')
        //     .addAttribute('for','login')
        //     .appendTo(loginBlock);
        const name = config.projectTitle.split(' ').join('').toLowerCase();

        const userPassword = new BaseElement('input')
            .addClass('password-input','protected-input')
            .addAttribute('type','password')
            .addAttribute('id','password')
            .addAttribute('name',`password_${name}`)
            .addAttribute('required',true)
            .event('input',this.removeError.bind(this))
            .appendTo(passwordBlock)
            .DOMElement;

        new BaseElement('label')
            .addClass('protected-label')
            .innerHtml('Password')
            .addAttribute('for','password')
            .appendTo(passwordBlock);

        new BaseElement('div')
            .addClass('protected-show-password')
            .appendTo(passwordBlock)
            .event('click',() => this.showPassword(userPassword));

        new BaseElement('button')
            .addClass('protected-submit')
            .innerHtml('Sign in')
            .appendTo(body)
            .event('click',(e) => this.submit(e,userPassword));

        new BaseElement('h5')
            .addClass('protected-text')
            .appendTo(this.container)
            .innerHtml('For support, please call 03-5617003');


        return new Promise(resolve => {
            const interval = setInterval(() => {
                if (this.valid) {
                    clearInterval(interval);
                    this.container.remove();
                    resolve();
                }
            },200);
        });
    }

    submit(e,passwordElement) {
        e.preventDefault();
        const password = passwordElement.value;

        if (this.params.passwords.includes(password)) {
            passwordElement.value = '';
            this.valid = true;
        } else {
            passwordElement.classList.add('protected-error');
        }
    }

    showPassword(element) {
        const type = element.getAttribute('type');
        if (type === 'password') {
            element.setAttribute('type','text');
        } else {
            element.setAttribute('type','password');
        }
    }

    removeError(e) {
        e.target.classList.remove('protected-error');
    }

}
